import type { AbstractAuthenticationToken, AuthenticationConverter } from './types.ts';

const BASIC = 'Basic ';

export const httpBasicAuthenticationConverter = (opts?: {credentialsEncoding?: BufferEncoding}): AuthenticationConverter => {
    const credentialsEncoding = opts?.credentialsEncoding ?? 'utf-8';

    return async (exchange): Promise<AbstractAuthenticationToken | undefined> => {
        const { request } = exchange;
        const authorization = request.headers.one("authorization");
        if (!authorization || !(/basic/i).test(authorization.substring(0,))) {
            return;
        }
        const credentials = authorization.length <= BASIC.length ? '' : authorization.substring(BASIC.length);
        const decoded = Buffer.from(credentials, 'base64').toString(credentialsEncoding);
        const parts = decoded.split(":", 2);
        if (parts.length !== 2) {
            return undefined;
        }
        const principal = parts[0];
        let erasableCredentials: string | null = parts[1];
        return {
            type: 'UsernamePassword',
            authenticated: false,
            principal,
            credentials: erasableCredentials,
            name: principal,
            eraseCredentials: () => {
                erasableCredentials = null;
            },
        };
    }

}
